export enum DrawerStates {
  EXPANDED = "expanded",
  COLLAPSED = "collapsed",
  CLOSED = "closed",
}

export default DrawerStates
